import {Collapse, Grid} from "@mui/material";
import {useCallback, useState} from "react";
import MhdSelect from "../../atomicComponents/MhdSelect";
import {euvFilterChoices, mapResolutionChoices} from "../../../utils/choices";
import MhdInput from "../../atomicComponents/MhdInput";
import WidgetSwitch from "../../atomicComponents/WidgetSwitch";
import {setAndUpdate, validateAndUpdate} from "../../../utils/helpers";
import MhdWidgetDivider from "../../atomicComponents/MhdWidgetDivider";

const SliceWidget = ({data, mods, warn, errs, update, setter}) => {

  return (
    <Grid container spacing={1}>
      <Grid item xs={4}>
        <WidgetSwitch
          label="Apply Vignette"
          value={data.vignette_function}
          onChange={useCallback((v) => setAndUpdate("vignette_function", v, setter, update), [])}
        />
      </Grid>
      <Grid item xs={4}>
        <MhdInput
          label='Radial Power'
          value={data.radial_power}
          override={mods.radial_power}
          warning={warn.radial_power}
          error={errs.radial_power}
          onChange={useCallback((v) => validateAndUpdate("radial_power", v, setter, update), [])}
        />
      </Grid>
      <Grid item xs={4}>
        <WidgetSwitch
          label="Logscale"
          value={data.log_transform}
          onChange={useCallback((v) => setAndUpdate("log_transform", v, setter, update), [])}
        />
      </Grid>
      <Grid item xs={12}>
        <MhdSelect
          label="Map Resolution"
          value={data.resolution}
          override={mods.resolution}
          warning={warn.resolution}
          error={errs.resolution}
          onChange={useCallback((v) => setAndUpdate("resolution", v, setter, update), [])}
          choices={mapResolutionChoices}
        />
      </Grid>
    </Grid>
  );
}

export default SliceWidget;